module.exports = __webpack_public_path__ + "static/img/9.9935c63.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/eng/9.png
// module id = bUFy
// module chunks = 0